<template>
    <div class="page-content">
        <div class="page-body">
            <div class="membership-navigation">
                <div class="membership-content membership-margin">
                    <div class="app-standardpage-header mb-2">
                      {{$t('membership.title')}}
                      <span class="go-to-dashboard"> 
                        <BtnLink
                          @click.native="goToDashboard()"
                          class="flex-column border-radius font-weight-500"
                          :label="$t('membership.goToDashboard')"
                        />
                      </span>
                    </div>
                    <NavigationTabs v-model="currentTabComponent" :navItems="navItems" />
                </div>  
            </div>

            <component ref="mobileRenderer" v-bind:is="currentComponent"></component>
        </div>
    </div>
</template>

<script>
import NavigationTabs from '@/components/UI/NavigationTabs';
import Membership from '@/views/Membership.vue';
import Invoice from '@/views/Invoice.vue';

export default {
  name: 'MembershipHome',
  components: {
    NavigationTabs
  },
  data() {
    return {
      currentTabComponent: 'my-membership',
    };
  },
  computed: {
    navItems() {
      let items = [
        { code: 'my-membership', label: this.$t('membership.tabMembership') },
        { code: 'my-invoices', label: this.$t('membership.tabInvoice') },
      ];
      return items;
    },
    currentComponent() {
      if(this.currentTabComponent == 'my-membership') {
          return Membership
      }
      return Invoice
    },
  },
  methods: {
    goToDashboard() {
      this.$router.push('/dashboard');
    }
  }
};
</script>


<style lang="scss" scoped>
@import '@/styles/style.scss';

.page-content {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-color: $very-light-grey;
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.page-body {
  overflow: auto;
}

.membership-navigation {
  background-color: white;
  padding-top: 68px;
  flex-shrink: 0;
  flex-grow: 0;
  }

.membership-content {
  display: flex;
  flex-direction: column;
}

.membership-margin {
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding-left: $mobile-margin-left;
  padding-right: $mobile-margin-left;
  color: $dark-grey;
}

.membership-details {
  max-width: 800px;
  color: $white;
  background-color: $membership;
  border-radius: 9px;
  display: flex;
  justify-content: space-between;
  padding: 10px;
}

@media screen and (min-width: 481px) {
  .membership-margin {
    margin-left: $desktop-margin-left !important;
    padding: 0px;
  }
}
</style>